import { defineStore } from 'pinia';

export default defineStore('notificationToasts', {
  state: () => ({
    toasts: [],
    id: 0,
  }),
  getters: {
    notificationToasts(state) {
      return state.toasts;
    },
  },
  actions: {
    addNotificationToast(payload) {
      this.toasts.unshift({ id: this.id, ...payload });
      this.id += 1;
    },
    removeNotificationToast(id) {
      this.toasts = this.notificationToasts.filter((item) => item.id !== id);
    },
  },
});
